import React from "react";
import DashboardLayout from "../components/DashboardLayout";

function Shipment() {
  return (
    <DashboardLayout headerTitle="Shipments">
      <div className="mt-[20px] text-center">Page Contents</div>
    </DashboardLayout>
  );
}

export default Shipment;
